<template>
  <BaseModal
    :id="`reportInappropriate_${reviewUid}`"
    :title="$label('books.reviews.reportReviewModalTitle')"
  >
    <template #body>
      <label>{{ $label('books.reviews.reportReviewFormTitle') }}</label>

      <div
        v-for="reason in possibleReasons"
        :key="reason"
        class="form-check mt-16"
      >
        <input
          :id="reason"
          v-model="reportReason"
          name="reportReviewReason"
          :value="reason"
          class="form-check-input"
          type="radio"
        />
        <label class="form-check-label" :for="reason">
          {{ reason }}
        </label>
      </div>
    </template>

    <template #footer>
      <BaseButton
        variant="primary"
        type="submit"
        :class="['confirm-btn', { loading: isLoading }]"
        :disabled="!reportReason"
        @click="submitForm"
      >
        {{ $label('books.reviews.reportReviewFormConfirm') }}
      </BaseButton>
      <BaseButton variant="secondary" class="cancel-btn" @click="hideModal">
        {{ $label('common.cancel') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '~/components/BaseModal'

export default {
  components: {
    BaseModal,
  },
  props: {
    reviewUid: {
      type: String,
      default: '',
    },
    reportReview: {
      type: Function,
      required: true,
    },
    hideModal: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      reportReason: '',
    }
  },
  computed: {
    possibleReasons() {
      return ['first', 'second', 'third'].map((reason) =>
        this.$label(`books.reviews.reportReviewReason.${reason}`),
      )
    },
  },
  methods: {
    async submitForm() {
      try {
        this.isLoading = true

        await this.reportReview({
          reviewUid: this.reviewUid,
          reason: this.reportReason,
        })

        this.$toast.success(this.$label('books.reviews.reviewReported'))
      } catch (error) {
        this.onError(error)
      } finally {
        this.isLoading = false
        this.hideModal()
      }
    },
    onError(error) {
      let label = this.$label('messages.errorOccuredMessage')

      if (
        this.$error.getErrorCode(error) === 'Reviews.DuplicateInappropriateVote'
      ) {
        label = this.$label('books.reviews.duplicateInappropriateVote')
      } else {
        this.$sentryCaptureException(error)
      }

      this.$toast.error(label)
    },
  },
}
</script>

<style lang="scss" scoped>
.form-check-label {
  font-size: $font-size-base;
  line-height: $line-height-base;
  font-weight: normal;
}
</style>
